import React, { Component } from 'react';
import config from '../config';
import axios from 'axios'
import loader from '../images/ajax-loader.gif'
import { withRouter } from 'react-router-dom';
import { FixedSizeList as List } from "react-window";

import Select from 'react-select';

import '../App.css';
import Switch from "react-switch";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import QuotedConfigurationDetails from './components/quotes/QuotedConfigurationDetails';
import TopProgressBarLoader from './components/shared/loaders/TopProgressBarLoader';
import ScreenOverlayLoader from './components/shared/loaders/ScreenOverlayLoader';

// Be sure to include styles at some point, probably during your bootstrapping
// import '../../node_modules/react-select/dist/css/react-select.css';
const height = 35;

class QuotesNew extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            errorMessage:null,
            netSetupAndRunPercentage: 0.8,
            netItemPricePercentage: 0.6,
            productList: [],
            productListLoader: true,
            selectedProduct: "",
            selectedProductName: "",
            selectedProductErr: "",
            selectedProductPricingData: [],
            selectedProductPricingLoader: false,
            productQuantityInputValue: "",
            productQuantityInputErr: "",
            quantityPrice: 0,
            // totalProductPrice: 0,
            totalCodedPrice: 0,
            perItemCodedPrice: 0,

            selectedPriceBracket: "",
            currencyList: [{ value: "USD", label: "USD" }, { value: "CAD", label: "CAD" }],
            selectedCurrency: "USD",
            //===changes
            locationInputErr: "",
            productLocationInputValue: 1,
            selectedArtChoice: "true",
            artChoiceInputErr: "",
            decoData: [],
            selectedDeco1: "",
            colorsMax1: "",
            colorsInputErr1: "",
            productColorsInputValue1: "1",
            selectedProductBU: "",
            setupPrice1: 0,
            setupchargeData: [],
            selectedDeco2: "",
            colorsMax2: "",
            colorsInputErr2: "",
            productColorsInputValue2: "1",
            setupPrice2: 0,
            listOfRunCharge: [],
            selectedProductDetails: "",
            lstCustomerPrice: [],
            //lstExceptionCategory:[],
            codedPrice: 0.00,
            netPrice: 0.00,
            loc1Runchrg: 0.00,
            loc2Runchrg: 0.00,
            userSelectedProduct: "",
            stitchCountLoc1: 4400,
            stitchCountLoc2:12000,
            selectedPriceLevel: "Column",
            displayTable: [],
            percentageOffValue: 0.0,
            showQty: true,
            artQty1: 0,
            artQty2: 0,
            turnTime: 0,
            extTurnTime: 0,
            CheckedValue : false,
            ToggleValue : "Coded",
            isProductChanged:false,
            Loc1PricingType:"",
            Loc2PricingType:"",
            selectedMethodIsDefault:false,

            DisplayColor1:"",
            DisplayColor2:""
        }
         this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        var page = this;

        // Get all products
        this.getAllProducts();
        //===changes
        this.getDecoData();


    }

    componentDidUpdate() { }

    getAllProducts() {
        var page = this;
        var data = new FormData();
        const formConfig = {
            method: 'get',
            // url: config.PCNA_SERVICE_URL + "CRUD/getAllProductCode",
            url: config.PCNA_SERVICE_URL + "getAllProductList",
            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        this.setState({loading:true});
        axios(formConfig)
            .then(function (response) {
                if (response.data.errorMsg == "") {
                    //var productData = response.data.getProductDateModifiedResponse.productDateModifiedArray;
                    // var productData = response.data.productSellableArray;
                    var productData = response.data.lstProductIDwithPartID;

                    if (productData.length > 0) {
                        page.setState({
                            productList: productData
                        }, () => {
                            page.setState({ productListLoader: false, selectedProductErr: "", productListLoader: false, loading:false });  // loader functionality
                        });
                    }
                }
                else {
                    page.setState({ selectedProductErr: response.data.errorMsg, productListLoader: false, loading:false })
                }
            })
            .catch((error) => {
                // Show Error while fetching data
                page.setState({ productListLoader: false, loading:false });
            });
    }

    getProductPricing(e) {
        this.setState({errorMessage:null, loading:true});
        var page = this;
        // var selectedProduct = e.target.value;
        var selectedProduct = e.value;
        document.getElementById("quantityField").removeAttribute("disabled");
        document.getElementById("drpPricelevel").removeAttribute("disabled");
       // document.getElementById("colorField").removeAttribute("disabled");
        document.getElementById("locationField").removeAttribute("disabled");//
        document.getElementById("drpArtChoice").removeAttribute("disabled");
        document.getElementById("drpDeco1").removeAttribute("disabled"); //
        document.getElementById("loc1ColorNo").removeAttribute("disabled");

        var colr1 = ""
        var colr2 = ""
        if (page.state.productColorsInputValue1 == "" || page.state.productColorsInputValue1 == undefined) {
            colr1 = "0";
        }
        else {
            colr1 = page.state.productColorsInputValue1;
        }
        if (page.state.productColorsInputValue2 == "" || page.state.productColorsInputValue2 == undefined) {
            colr2 = "0";
        }
        else {
            colr2 = page.state.productColorsInputValue2;
        }
        page.setState({
            decoData : [],
            isProductChanged:true
        })
        var artLocation = (page.state.productLocationInputValue != undefined && page.state.productLocationInputValue != "") ? page.state.productLocationInputValue : 0
        var data = new FormData();
        const formConfig1 = {
            method: 'get',
            // url: config.PCNA_SERVICE_URL + "ProductDetails/" + selectedProduct + "/" + page.state.selectedDeco1 + "/"
            //     + page.state.selectedDeco2 + "/" + colr1 + "/" + colr2 + "/" + page.state.stitchCountLoc1 + "/" + page.state.stitchCountLoc2 +
            //     "/" + artLocation + "/" + page.state.selectedArtChoice,
            url:config.PCNA_SERVICE_URL+"GetProductDetails?ItemCode="+selectedProduct+"&DecoLoc1="+ page.state.selectedDeco1 +            
            "&DecoLoc2="+ page.state.selectedDeco2 +"&noColor1="+ colr1 +"&noColor2="+ colr2 +"&StitchCountLoc1="+ page.state.stitchCountLoc1 +
            "&StitchCountLoc2="+ page.state.stitchCountLoc2 +"&ArtNo="+artLocation+"&SameArtType="+ page.state.selectedArtChoice,
            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        axios(formConfig1)
            .then(function (response) {
                var selectedProductDetails = response.data.objProduct
                var selectedBU = selectedProductDetails.bu
                
                if (selectedProductDetails != undefined && selectedProductDetails != "") {
                    page.state.showQty = false

                    if(response.data.applicableDecoMethods.length > 0){
                        page.state.decoData = response.data.applicableDecoMethods 
                        page.state.colorsMax1 = response.data.applicableDecoMethods[0]?.colorsMax
                        page.state.selectedDeco1= response.data.applicableDecoMethods[0]?.name
                        page.state.selectedDeco2= response.data.applicableDecoMethods[0]?.name
                        page.state.colorsMax2= response.data.applicableDecoMethods[0]?.colorsMax
                    }
                }

                if(response.data.errorMsg==""){
                    page.setState({errorMessage:!!response.data?.applicableDecoMethods && 
                        response.data.applicableDecoMethods.length < 1 ? "No deco methods found for the selected product" : null});

                    page.setState({
                        selectedProductDetails: response.data.objProduct,
                        artQty1: response.data.artQty1,
                        artQty2: response.data.artQty2,
                        selectedProductBU: selectedProductDetails.bu,
                        selectedProductName: selectedProductDetails.description + "(" + selectedProductDetails.itemCode + ")",
                        userSelectedProduct: selectedProduct,
                        displayTable: selectedProductDetails.lstDiffPrices,
                        Loc1PricingType:response.data.objProduct.loc1PricingType,
                        Loc2PricingType:response.data.objProduct.loc2PricingType,
                        selectedMethodIsDefault:response.data.selectedMethodIsDefault,
                        loading:false,

                        DisplayColor1:response.data.displayColor1,
                        DisplayColor2:response.data.displayColor2
                    })
                    page.state.selectedProductBU = selectedBU
                    page.calculateSetupPrice1();
                    // if(page.state.selectedArtChoice.toLocaleLowerCase()=="no-different"){
                    page.calculateSetupPrice2();
                    // }

                    if (page.state.productQuantityInputValue != "" && page.state.productQuantityInputValue != undefined) {
                        page.checkProductPrice1(page.state.productQuantityInputValue);
                    }
                }
                else{
                    page.setState({errorMessage:response.data.errorMsg, loading:false})
                }    
                
            }).catch(err => {
                // this.setState({errorMessage:err.message})
                page.setState({loading:false});
            })
    }

    handleChange(checked) {
        this.setState({ 
            CheckedValue : checked, 
            ToggleValue : checked ? "Net" : "Coded"
        });
    }

    applyPercentage = (amount, percentageMultiplier, round = false) => 
        round === true ? (Math.round((amount * 100 * percentageMultiplier))/100).toFixed(3) : 
        (amount * percentageMultiplier).toFixed(3);


    exportExcel() {

        // Excel Generation
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        var fileName = this.state.ToggleValue + "_Quotes";
        var createdSheets = []
        var createdSheetNames = [this.state.ToggleValue + "_Quotes"]
        var ExcelValues = []

        var page = this;
        // console.log("Decoooooo1111")
        // console.log(page.state.artQty1)
        // console.log(page.state.artQty2)
        var locationValue = (page.state.productLocationInputValue != undefined && page.state.productLocationInputValue != "") ?
            page.state.productLocationInputValue : 0;
        var qty = (page.state.productQuantityInputValue != undefined && page.state.productQuantityInputValue != "") ?
            page.state.productQuantityInputValue : 0;
        var setupPrice1 = (page.state.setupPrice1 != undefined && page.state.setupPrice1 != "") ?
            (page.state.selectedArtChoice == "true" ? page.state.setupPrice1 * locationValue : page.state.setupPrice1) : 0.00;
        var setupPrice2 = (page.state.setupPrice2 != undefined && page.state.setupPrice2 != "") ?
            (page.state.selectedArtChoice != "true" ? page.state.setupPrice2 : 0.00) : 0.00;
        // var deco1 = (page.state.artQty1 != undefined && page.state.artQty1 != "") ?
        //     (page.state.selectedArtChoice == "true" ? (page.state.artQty1 * locationValue * qty) : (page.state.artQty1 * qty)) : 0.00;
        var deco1 = (page.state.artQty1 != undefined && page.state.artQty1 != "") ? (page.state.artQty1 * qty) : 0.00;
        var deco2 = (page.state.artQty2 != undefined && page.state.artQty2 != "") ?
            (page.state.selectedArtChoice != "true" ? (page.state.artQty2 * 1 * qty) : 0.00) : 0.00;
        let Runcharge1 = (page.state.loc1Runchrg != "" && page.state.loc1Runchrg != undefined) ?
            page.state.loc1Runchrg * deco1.toFixed(3) : 0.00
        var Runcharge2 = (page.state.loc2Runchrg != "" && page.state.loc2Runchrg != undefined) ?
            page.state.loc2Runchrg * deco2.toFixed(3) : 0.00

        var NameForToggleValues = ""

        const decoData1 = this.state.decoData?.filter(
            (d) => d.name === this.state.selectedDeco1
          )[0];
          const decoData2 = this.state.decoData?.filter(
            (d) => d.name === this.state.selectedDeco2
          )[0];

        if(this.state.ToggleValue === "Coded"){
            NameForToggleValues = "Coded"
        }
        else{
            NameForToggleValues = "Net"
        }
        var CodedValues = {
            "": "",
            [NameForToggleValues]:  "",
        }
        ExcelValues.push(CodedValues)
        
        CodedValues = {
            "": "Item Unit Price",
            [NameForToggleValues]: NameForToggleValues == "Coded" ? parseFloat(this.state.perItemCodedPrice).toFixed(3) : parseFloat(page.state.perItemCodedPrice * 0.60).toFixed(3)
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "Qty Quoted",
            [NameForToggleValues]: (this.state.productQuantityInputValue != undefined && this.state.productQuantityInputValue != "") ?
            this.state.productQuantityInputValue : 0
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "Item Total",
            [NameForToggleValues]: NameForToggleValues == "Coded" ? this.state.totalCodedPrice.toFixed(3) : (page.state.totalCodedPrice.toFixed(3) * 0.60).toFixed(3)
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "",
            [NameForToggleValues]: ""
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "Decoration:",
            [NameForToggleValues]: ""
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "Setup Total",
            // [NameForToggleValues]: NameForToggleValues == "Coded" ? (Math.round(setupPrice1, 3) + Math.round(setupPrice2, 3)) : ((Math.round(setupPrice1, 3) + Math.round(setupPrice2, 3))* 0.80).toFixed(3)
            [NameForToggleValues]: NameForToggleValues == "Coded" ? (setupPrice1 + setupPrice2) : ((setupPrice1 + setupPrice2)* 0.80).toFixed(3)
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "Run Total",
            // [NameForToggleValues]: NameForToggleValues == "Coded" ? (Math.round(Runcharge1, 3) + Math.round(Runcharge2, 3)) : ((Math.round(Runcharge1, 3) + Math.round(Runcharge2, 3)) * 0.80).toFixed(3) 
            [NameForToggleValues]: NameForToggleValues == "Coded" ? (Runcharge1 + Runcharge2).toFixed(3) : ((Runcharge1 + Runcharge2) * 0.80).toFixed(3) 
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "",
            [NameForToggleValues]: "" 
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "Configured Item Total",
            [NameForToggleValues]:NameForToggleValues == "Coded" ? 
                (((parseFloat(page.state.perItemCodedPrice) * parseFloat(qty))) +
                ((parseFloat(setupPrice1) + parseFloat(setupPrice2))) +
                ((parseFloat(Runcharge1) + parseFloat(Runcharge2)))).toFixed(3) 
                : 
                (((parseFloat(page.state.perItemCodedPrice) * parseFloat(qty)) * 0.60) +
                ((parseFloat(setupPrice1) + parseFloat(setupPrice2)) * 0.80) +
                ((parseFloat(Runcharge1) + parseFloat(Runcharge2)) * 0.80)).toFixed(3)
    }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "",
            [NameForToggleValues]: "" 
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "Configured Unit Price",
            [NameForToggleValues]: NameForToggleValues == "Coded" ? 
                    ((((parseFloat(page.state.perItemCodedPrice) * parseFloat(qty))) +
                    ((parseFloat(setupPrice1) + parseFloat(setupPrice2))) +
                    ((parseFloat(Runcharge1) + parseFloat(Runcharge2)))) / qty).toFixed(3)
                    :
                    ((((parseFloat(page.state.perItemCodedPrice) * parseFloat(qty)) * 0.60) +
                    ((parseFloat(setupPrice1) + parseFloat(setupPrice2)) * 0.80) +
                    ((parseFloat(Runcharge1) + parseFloat(Runcharge2)) * 0.80)) / qty).toFixed(3)
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "",
            [NameForToggleValues]: "" 
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "",
            [NameForToggleValues]: "" 
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "Quoted Configuration Detail:",
            [NameForToggleValues]: "" 
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "Item Number",
            [NameForToggleValues]: page.state.userSelectedProduct
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "Deco Locations per Item",
            [NameForToggleValues]: page.state.productLocationInputValue
        }
        ExcelValues.push(CodedValues)

        if(page.state.productLocationInputValue > 1){
            CodedValues = {
                "": "Art Same/Different",
                [NameForToggleValues]: page.state.selectedArtChoice === "true" ? "Same" : "Different"
            }
            ExcelValues.push(CodedValues)
        }

        CodedValues = {
            "": "",
            [NameForToggleValues]: ""
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "Location 1",
            [NameForToggleValues]: ""
        }
        ExcelValues.push(CodedValues)

        CodedValues = {
            "": "Deco Method",
            [NameForToggleValues]: decoData1?.hyphanateName
        }
        ExcelValues.push(CodedValues)

        if(page.state.selectedDeco1 === "Embroidery"){
            CodedValues = {
                "": "Stich Count",
                [NameForToggleValues]: page.state.stitchCountLoc1
            }
            ExcelValues.push(CodedValues)
        }
        
        CodedValues = {
            "": "Number of Colors",
            [NameForToggleValues]: page.state.productColorsInputValue1
        }
        ExcelValues.push(CodedValues)
        
        CodedValues = {
            "": "Setup",
            // [NameForToggleValues]: "$" + Math.round((this.state.ToggleValue === "Coded" ? setupPrice1 : setupPrice1 * this.state.netSetupAndRunPercentage), 3).toFixed(3) 
            [NameForToggleValues]: "$" + (this.state.ToggleValue === "Coded" ? setupPrice1 : setupPrice1 * this.state.netSetupAndRunPercentage).toFixed(3) 
        }
        ExcelValues.push(CodedValues)
        
        CodedValues = {
            "": "Run",
            // [NameForToggleValues]: "$" + Math.round((this.state.ToggleValue === "Coded" ? Runcharge1 : Runcharge1 * this.state.netSetupAndRunPercentage), 3).toFixed(3) 
            [NameForToggleValues]: "$" + (this.state.ToggleValue === "Coded" ? Runcharge1 : Runcharge1 * this.state.netSetupAndRunPercentage).toFixed(3) 
        }
        ExcelValues.push(CodedValues)

        if(page.state.productLocationInputValue > 1){
            CodedValues = {
                "": "",
                [NameForToggleValues]: ""
            }
            ExcelValues.push(CodedValues)

            CodedValues = {
                "": "Location 2",
                [NameForToggleValues]: ""
            }
            ExcelValues.push(CodedValues)

            CodedValues = {
                "": "Deco Method",
                [NameForToggleValues]: decoData2?.hyphanateName
            }
            ExcelValues.push(CodedValues)

            if(page.state.selectedDeco2 === "Embroidery"){
                CodedValues = {
                    "": "Stich Count",
                    [NameForToggleValues]: page.state.stitchCountLoc2
                }
                ExcelValues.push(CodedValues)
            }
            
            CodedValues = {
                "": "Number of Colors",
                [NameForToggleValues]: page.state.productColorsInputValue2
            }
            ExcelValues.push(CodedValues)

            CodedValues = {
                "": "Setup",
                // [NameForToggleValues]: "$" + Math.round(this.state.ToggleValue === "Coded" ? setupPrice2 : setupPrice2 * this.state.netSetupAndRunPercentage, 3).toFixed(3)
                [NameForToggleValues]: "$" + (this.state.ToggleValue === "Coded" ? setupPrice2 : setupPrice2 * this.state.netSetupAndRunPercentage).toFixed(3)
            }
            ExcelValues.push(CodedValues)

            CodedValues = {
                "": "Run",
                // [NameForToggleValues]: "$" + Math.round((this.state.ToggleValue === "Coded" ? Runcharge2 : Runcharge2 * this.state.netSetupAndRunPercentage), 3).toFixed(3)
                [NameForToggleValues]: "$" + (this.state.ToggleValue === "Coded" ? Runcharge2 : Runcharge2 * this.state.netSetupAndRunPercentage).toFixed(3)
            }
            ExcelValues.push(CodedValues)

        }

        createdSheets[this.state.ToggleValue + "_Quotes"] = XLSX.utils.json_to_sheet(ExcelValues);
    
        // else{

        // }

        const wb = { Sheets: createdSheets, SheetNames: createdSheetNames };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        //Excel Generation Ends
    }

    selectCurrency(e) {
        var page = this;
        page.setState({ selectedCurrency: e.value })
    }

    checkProductPrice(e) {// called on button
        var page = this;
        var productQuantity = e.target.value;

        if (/^\d*$/.test(productQuantity)) {
            page.setState({
                productQuantityInputValue: e.target.value,
                productQuantityInputErr: ""
            }, () => {
                //Get price based on quantity
                var selectedProductPricingData = page.state.selectedProductDetails;
                var quantityPrice = 0;
                var codedPrice = 0;
                var netPrice = 0;
                var loc1Runchrg = 0;
                var loc2Runchrg = 0;
                var bCoded = 0;
                var selectedPriceBracket = "";
                var qty = selectedProductPricingData.lstDiffPrices[0].begQty;
                var productQuantityInputErr=""
                
                if (selectedProductPricingData.lstDiffPrices.length > 0) {
                    if (parseFloat(selectedProductPricingData.lstDiffPrices[0].begQty) > parseFloat(productQuantity)) {
                        //quantityPrice = selectedProductPricingData.lstDiffPrices[0].price;
                        // selectedPriceBracket = 0;
                        // codedPrice = selectedProductPricingData.lstDiffPrices[0].coded;
                        // netPrice = selectedProductPricingData.lstDiffPrices[0].net;
                        // loc1Runchrg = selectedProductPricingData.lstDiffPrices[0].runChargeLoc1;
                        // loc2Runchrg = selectedProductPricingData.lstDiffPrices[0].runChargeLoc2;
                        // bCoded = selectedProductPricingData.lstDiffPrices[0].bCoded;
                        productQuantityInputErr="Quantity below LTM"
                    }
                    else if (parseFloat(selectedProductPricingData.lstDiffPrices[selectedProductPricingData.lstDiffPrices.length - 1].begQty) <= 
                    parseFloat(productQuantity)) {
                        //quantityPrice = selectedProductPricingData.lstDiffPrices[selectedProductPricingData.length - 1].price;
                        selectedPriceBracket = selectedProductPricingData.lstDiffPrices.length - 1;
                        codedPrice = selectedProductPricingData.lstDiffPrices[selectedProductPricingData.lstDiffPrices.length - 1].coded;
                        netPrice = selectedProductPricingData.lstDiffPrices[selectedProductPricingData.lstDiffPrices.length - 1].net;
                        loc1Runchrg = selectedProductPricingData.lstDiffPrices[selectedProductPricingData.lstDiffPrices.length - 1].runChargeLoc1;
                        loc2Runchrg = selectedProductPricingData.lstDiffPrices[selectedProductPricingData.lstDiffPrices.length - 1].runChargeLoc2;
                        bCoded = selectedProductPricingData.lstDiffPrices[selectedProductPricingData.lstDiffPrices.length - 1].bCoded;
                        productQuantityInputErr=""
                    }
                    else {
                        for (var i = 0; i < selectedProductPricingData.lstDiffPrices.length; i++) {
                            var lg = i + 1;
                            if ((parseFloat(selectedProductPricingData.lstDiffPrices[i].begQty) <= parseFloat(productQuantity))
                                && lg < selectedProductPricingData.lstDiffPrices.length) {
                                if (parseFloat(selectedProductPricingData.lstDiffPrices[i + 1].begQty) >= parseFloat(productQuantity)) {
                                    //quantityPrice = selectedProductPricingData.lstDiffPrices[i].price;
                                    selectedPriceBracket = i + 1;
                                    codedPrice = selectedProductPricingData.lstDiffPrices[i].coded;
                                    netPrice = selectedProductPricingData.lstDiffPrices[i].net;
                                    loc1Runchrg = selectedProductPricingData.lstDiffPrices[i].runChargeLoc1;
                                    loc2Runchrg = selectedProductPricingData.lstDiffPrices[i].runChargeLoc2;
                                    bCoded = selectedProductPricingData.lstDiffPrices[i].bCoded;
                                }
                            }
                            productQuantityInputErr=""
                        }
                    }

                    var productLocationInputValue = page.state.productLocationInputValue;
                    var selectedPriceLevel = page.state.selectedPriceLevel;
                    var perItemCodedPrice = 0;
                    var ColumnItemPrice = 0;
                    var MidpointItemPrice = 0;
                    var EQPPrice = 0;
                    var EQPpercentageoff = page.state.percentageOffValue;
                    
                    ColumnItemPrice = (productLocationInputValue == 0) ? bCoded : codedPrice;
                    MidpointItemPrice = (productLocationInputValue == 0) ? selectedProductPricingData.lstDiffPrices[3].bCoded :
                        selectedProductPricingData.lstDiffPrices[3].coded;
                    EQPPrice = (productLocationInputValue == 0) ? selectedProductPricingData.lstDiffPrices[5].bCoded :
                        selectedProductPricingData.lstDiffPrices[5].coded;
                    if (selectedPriceLevel == "MidPoint") {
                        perItemCodedPrice = Math.min(ColumnItemPrice, MidpointItemPrice)
                    }
                    else if (selectedPriceLevel == "EQP") {
                        perItemCodedPrice = Math.min(ColumnItemPrice, EQPPrice)

                    }
                    else if (selectedPriceLevel == "EQP-%") {
                        perItemCodedPrice = Math.min(ColumnItemPrice, EQPPrice * (1 - (EQPpercentageoff/100)))
                    }
                    else {
                        perItemCodedPrice = ColumnItemPrice
                    }
                    var productQuantityInputValue = page.state.productQuantityInputValue

                    var totalCodedPrice = perItemCodedPrice * productQuantityInputValue
                    var turnTimeLoc1 = 0
                    var turnTimeLoc2 = 0
                    var turnTime = 0
                    var extTurnTime1 = 0
                    var extTurnTime2 = 0
                    var extTurnTime = 0
                    ////turnTimeLoc1
                    
                    
                    if (page.state.productLocationInputValue > 0) {
                        if (page.state.selectedDeco1 == "Embroidery" || page.state.selectedProductDetails.itemCode.substring(0, 2) == "TM") {
                            if (page.state.selectedArtChoice != "true") {
                                turnTimeLoc1 = Math.ceil(productQuantity / selectedProductPricingData.lstDiffPrices[2].begQty, 0)
                            }
                            else {
                                turnTimeLoc1 = Math.ceil(((productQuantity * productLocationInputValue) / selectedProductPricingData.lstDiffPrices[2].begQty, 0), 0)
                            }
                        }
                        else {
                            if (page.state.selectedArtChoice != "true") {
                                turnTimeLoc1 = Math.ceil((productQuantity / selectedProductPricingData.lstDiffPrices[5].begQty), 0)
                            }
                            else {
                                turnTimeLoc1 = Math.ceil(((productQuantity * productLocationInputValue) / selectedProductPricingData.lstDiffPrices[5].begQty), 0)
                            }
                        }
                        ////turnTimeLoc1
                        ////turnTimeLoc2
                        if (page.state.selectedDeco2 == "Embroidery" || page.state.selectedProductDetails.itemCode.substring(0, 2) == "TM") {
                            if (page.state.selectedArtChoice != "true") {
                                turnTimeLoc2 = Math.ceil((productQuantity / selectedProductPricingData.lstDiffPrices[2].begQty), 0)
                            }
                        }
                        else {
                            if (page.state.selectedArtChoice != "true") {
                                turnTimeLoc2 = Math.ceil((productQuantity / selectedProductPricingData.lstDiffPrices[5].begQty, 0))
                            }
                        }
                        ////turnTimeLoc2
                        var turnTime = turnTimeLoc1 + turnTimeLoc2
                    } else { turnTime = 1 }

                    var extTurnTime1 = Math.round(Math.min(Math.max(turnTimeLoc1 / 2, 7), turnTimeLoc1), 0)  //ROUNDUP(MIN(MAX(I60/2,7),I60),0)
                    var extTurnTime2 = Math.round(Math.min(Math.max(turnTimeLoc2 / 2, 7), turnTimeLoc2), 0)
                    var extTurnTime = extTurnTime1 + extTurnTime2

                    page.setState({
                        codedPrice: codedPrice, netPrice: netPrice, loc1Runchrg: loc1Runchrg, loc2Runchrg: loc2Runchrg,
                        totalCodedPrice: totalCodedPrice, selectedPriceBracket: selectedPriceBracket,
                        perItemCodedPrice: perItemCodedPrice, turnTime: turnTime, extTurnTime: extTurnTime, 
                        productQuantityInputErr:productQuantityInputErr
                    });
                }
            });
        }
        else {
            page.setState({ productQuantityInputValue: e.target.value, productQuantityInputErr: "Please enter valid quantity" });
        }
    }

    checkProductPrice1(qty) {// called on change of setup deco
        var page = this;
        var productQuantity = qty;

        if (/^\d*$/.test(productQuantity)) {
            page.setState({
                productQuantityInputValue: qty,
                productQuantityInputErr: ""
            }, () => {
                //Get price based on quantity
                var selectedProductPricingData = page.state.selectedProductDetails;
                var quantityPrice = 0;
                var codedPrice = 0;
                var netPrice = 0;
                var loc1Runchrg = 0;
                var loc2Runchrg = 0;
                var bCoded = 0;
                var selectedPriceBracket = "";
              //  var qty = selectedProductPricingData.lstDiffPrices[0].begQty;
                var productQuantityInputErr=""
                
                if (selectedProductPricingData.lstDiffPrices.length > 0) {
                    if (parseFloat(selectedProductPricingData.lstDiffPrices[0].begQty) > parseFloat(productQuantity)) {
                        //quantityPrice = selectedProductPricingData.lstDiffPrices[0].price;
                        // selectedPriceBracket = 0;
                        // codedPrice = selectedProductPricingData.lstDiffPrices[0].coded;
                        // netPrice = selectedProductPricingData.lstDiffPrices[0].net;
                        // loc1Runchrg = selectedProductPricingData.lstDiffPrices[0].runChargeLoc1;
                        // loc2Runchrg = selectedProductPricingData.lstDiffPrices[0].runChargeLoc2;
                        // bCoded = selectedProductPricingData.lstDiffPrices[0].bCoded;
                        productQuantityInputErr="Quantity below LTM"
                    }
                    else if (parseFloat(selectedProductPricingData.lstDiffPrices[selectedProductPricingData.lstDiffPrices.length - 1].begQty) <= parseFloat(productQuantity)) {
                        //quantityPrice = selectedProductPricingData.lstDiffPrices[selectedProductPricingData.length - 1].price;
                        selectedPriceBracket = selectedProductPricingData.lstDiffPrices.length - 1;
                        codedPrice = selectedProductPricingData.lstDiffPrices[selectedProductPricingData.lstDiffPrices.length - 1].coded;
                        netPrice = selectedProductPricingData.lstDiffPrices[selectedProductPricingData.lstDiffPrices.length - 1].net;
                        loc1Runchrg = selectedProductPricingData.lstDiffPrices[selectedProductPricingData.lstDiffPrices.length - 1].runChargeLoc1;
                        loc2Runchrg = selectedProductPricingData.lstDiffPrices[selectedProductPricingData.lstDiffPrices.length - 1].runChargeLoc2;
                        bCoded = selectedProductPricingData.lstDiffPrices[selectedProductPricingData.lstDiffPrices.length - 1].bCoded;
                    }
                    else {
                        for (var i = 0; i < selectedProductPricingData.lstDiffPrices.length; i++) {
                            var lg = i + 1;
                            if ((parseFloat(selectedProductPricingData.lstDiffPrices[i].begQty) <= parseFloat(productQuantity)) && lg < selectedProductPricingData.lstDiffPrices.length) {
                                if (parseFloat(selectedProductPricingData.lstDiffPrices[i + 1].begQty) >= parseFloat(productQuantity)) {
                                    //quantityPrice = selectedProductPricingData.lstDiffPrices[i].price;
                                    selectedPriceBracket = i + 1;
                                    codedPrice = selectedProductPricingData.lstDiffPrices[i].coded;
                                    netPrice = selectedProductPricingData.lstDiffPrices[i].net;
                                    loc1Runchrg = selectedProductPricingData.lstDiffPrices[i].runChargeLoc1;
                                    loc2Runchrg = selectedProductPricingData.lstDiffPrices[i].runChargeLoc2;
                                    bCoded = selectedProductPricingData.lstDiffPrices[i].bCoded;
                                }
                            }
                        }
                    }

                    var productLocationInputValue = page.state.productLocationInputValue;
                    var selectedPriceLevel = page.state.selectedPriceLevel;
                    var perItemCodedPrice = 0;
                    var ColumnItemPrice = 0;
                    var MidpointItemPrice = 0;
                    var EQPPrice = 0;
                    var EQPpercentageoff = page.state.percentageOffValue;
                    
                    ColumnItemPrice = (productLocationInputValue == 0) ? bCoded : codedPrice;
                    MidpointItemPrice = (productLocationInputValue == 0) ? selectedProductPricingData.lstDiffPrices[3].bCoded :
                        selectedProductPricingData.lstDiffPrices[3].coded;
                    EQPPrice = (productLocationInputValue == 0) ? selectedProductPricingData.lstDiffPrices[5].bCoded :
                        selectedProductPricingData.lstDiffPrices[5].coded;
                    if (selectedPriceLevel == "MidPoint") {
                        perItemCodedPrice = Math.min(ColumnItemPrice, MidpointItemPrice)
                    }
                    else if (selectedPriceLevel == "EQP") {
                        perItemCodedPrice = Math.min(ColumnItemPrice, EQPPrice)
                    }
                    else if (selectedPriceLevel == "EQP-%") {
                        perItemCodedPrice = Math.min(ColumnItemPrice, EQPPrice * (1 - (EQPpercentageoff/100)))
                    }
                    else {
                        perItemCodedPrice = ColumnItemPrice
                    }
                    var productQuantityInputValue = page.state.productQuantityInputValue

                    var totalCodedPrice = perItemCodedPrice * productQuantityInputValue
                    var turnTimeLoc1 = 0
                    var turnTimeLoc2 = 0
                    var turnTime = 0
                    var extTurnTime1 = 0
                    var extTurnTime2 = 0
                    var extTurnTime = 0
                    ////turnTimeLoc1
                    
                    if (page.state.productLocationInputValue > 0) {
                        if (page.state.selectedDeco1 == "Embroidery" || page.state.selectedProductDetails.itemCode.substring(0, 2) == "TM") {
                            if (page.state.selectedArtChoice != "true") {
                                turnTimeLoc1 = Math.ceil(productQuantity / selectedProductPricingData.lstDiffPrices[2].begQty, 0)
                            }
                            else {
                                turnTimeLoc1 = Math.ceil((productQuantity * productLocationInputValue) / selectedProductPricingData.lstDiffPrices[2].begQty, 0)
                            }
                        }
                        else {
                            if (page.state.selectedArtChoice != "true") {
                                turnTimeLoc1 = Math.ceil(productQuantity / selectedProductPricingData.lstDiffPrices[5].begQty, 0)
                            }
                            else {
                                turnTimeLoc1 = Math.ceil((productQuantity * productLocationInputValue) / selectedProductPricingData.lstDiffPrices[5].begQty, 0)
                            }
                        }
                        ////turnTimeLoc1
                        ////turnTimeLoc2
                        if (page.state.selectedDeco2 == "Embroidery" || page.state.selectedProductDetails.itemCode.substring(0, 2) == "TM") {
                            if (page.state.selectedArtChoice != "true") {
                                turnTimeLoc2 = Math.ceil(productQuantity / selectedProductPricingData.lstDiffPrices[2].begQty, 0)
                            }
                        }
                        else {
                            if (page.state.selectedArtChoice != "true") {
                                turnTimeLoc2 = Math.ceil(productQuantity / selectedProductPricingData.lstDiffPrices[5].begQty, 0)
                            }
                        }
                        ////turnTimeLoc2
                        var turnTime = turnTimeLoc1 + turnTimeLoc2
                    }
                    else { turnTime = 1 }
                    var extTurnTime1 = Math.round(Math.min(Math.max(turnTimeLoc1 / 2, 7), turnTimeLoc1), 0)  //ROUNDUP(MIN(MAX(I60/2,7),I60),0)
                    var extTurnTime2 = Math.round(Math.min(Math.max(turnTimeLoc2 / 2, 7), turnTimeLoc2), 0)
                    var extTurnTime = extTurnTime1 + extTurnTime2

                    page.setState({
                        codedPrice: codedPrice, netPrice: netPrice, loc1Runchrg: loc1Runchrg, loc2Runchrg: loc2Runchrg,
                        totalCodedPrice: totalCodedPrice, selectedPriceBracket: selectedPriceBracket,
                        perItemCodedPrice: perItemCodedPrice, turnTime: turnTime, extTurnTime: extTurnTime, 
                        productQuantityInputErr:productQuantityInputErr
                    });
                }
            });
        }
        else {
            page.setState({ productQuantityInputValue: qty, productQuantityInputErr: "Please enter valid quantity" });
        }
    }

    checkProductLocation(e) {
        var page = this
        if(e.target.value<0){
            page.setState({
                locationInputErr: "Location can't be negative"
            })
        }
        else if (e.target.value >= 3 ) {
            page.setState({
                locationInputErr: "You cannot enter location greater than '2'"
            })
        }
        else {
            //var locValue=e.target.value
            if(e.target.value>=0 && e.target.value<2){
                this.state.selectedArtChoice="true"
            }
            this.state.productLocationInputValue = e.target.value
            page.setState({
                productLocationInputValue: e.target.value,
                locationInputErr: ""
            })
            if (page.state.productQuantityInputValue != "" && page.state.productQuantityInputValue != undefined) {
                //console.log("/////////checkProductLocation/////////////")
                page.getAllProductCallOninputChange();
                page.checkProductPrice1(page.state.productQuantityInputValue);
            }

        }
    }

    getArtchioce(e) {
        var selectedChoice = e.target.value
        this.state.selectedArtChoice = e.target.value
        this.setState({
            selectedArtChoice: selectedChoice,
            artChoiceInputErr: ""
        })
        console.log("/////////art choice/////////////")
        this.getAllProductCallOninputChange();
        this.checkProductPrice1(this.state.productQuantityInputValue);
    }

    getDecoData() {
        var page = this;
        var data = new FormData();
        const formConfig = {
            method: 'post',
            url: config.PCNA_SERVICE_URL + "AllDecoMethods",
            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        this.setState({loading:true});
        axios(formConfig)
            .then(function (response) {
                 // console.log("deco details on load|||||",response)
                 
                var firstDecoData = response.data.lstDecoMethods[0]
                var defaultPricelevel = response.data.lstCustomerLevels[0].name

                page.setState({
                    loading:false,
                    decoData: response.data.lstDecoMethods,
                    colorsMax1: firstDecoData.colorsMax,
                    selectedDeco1: firstDecoData.decoName,
                    setupchargeData: response.data.lstSetupCost,
                    selectedDeco2: firstDecoData.decoName,
                    colorsMax2: firstDecoData.colorsMax,
                    listOfRunCharge: response.data.lstRunCharges,
                    lstCustomerPrice: response.data.lstCustomerLevels,
                    selectedPriceLevel: defaultPricelevel
                    //lstExceptionCategory:response.data.lstExceptionCategory.value,
                })
            }).catch(err => {this.setState({loading:false});})
    }

    onselectDeco1(e) {
        
        //var runValue
        debugger
        var page = this
        if (e.target.value != "" && e.target.value != undefined) {            
            var MaxColor = ""
            var DecorationName = ""
            page.state.decoData.map((x) => {
                if (e.target.value == x.name) {
                    MaxColor = x.colorsMax
                    DecorationName = x.hyphanateName
                }
            })
            page.state.selectedDeco1 = e.target.value
            page.setState({
                DecorationFullName1 : DecorationName,
                colorsMax1 : MaxColor
            })
            // page.setState({

            //     colorsMax1: MaxColor
            // })
            //this.state.colorsMax1=MaxColor
            if (e.target.value != "Embroidery") {
                // page.setState({
                //     stitchCountLoc1: 0.00
                // })
                this.state.stitchCountLoc1=0.00
            }
            if (e.target.value == "Embroidery") {
                // page.setState({
                //     stitchCountLoc1: 4400
                // })
              //  
                this.state.stitchCountLoc1=4400
            }
            
            if (page.state.productColorsInputValue1 > MaxColor && MaxColor > 0) {
                page.setState({
                    colorsInputErr1: "You cannot enter colors greater than '" + page.state.colorsMax1 + "'"
                })    
            }
            page.calculateSetupPrice1();
            // console.log("/////////select deco 1/////////////")
            page.getAllProductCallOninputChange();
            page.checkProductPrice1(page.state.productQuantityInputValue);

        }
    }

    getAllProductCallOninputChange() {
        var page = this;
        var colr1 = ""
        var colr2 = ""
        if (page.state.productColorsInputValue1 == "" || page.state.productColorsInputValue1 == undefined) {
            colr1 = "0";
        }
        else {
            colr1 = page.state.productColorsInputValue1;
        }
        if (page.state.productColorsInputValue2 == "" || page.state.productColorsInputValue2 == undefined) {
            colr2 = "0";
        }
        else {
            colr2 = page.state.productColorsInputValue2;
        }
        page.state.decoData=[]
        var artLocation = (page.state.productLocationInputValue != undefined && page.state.productLocationInputValue != "") ? page.state.productLocationInputValue : 0
        var data = new FormData();
        const formConfig1 = {
            method: 'get',
            // url: config.PCNA_SERVICE_URL + "ProductDetails/" + page.state.userSelectedProduct + "/"
            //     + page.state.selectedDeco1 + "/" + page.state.selectedDeco2 +
            //     "/" + colr1 + "/" + colr2 + "/" + page.state.stitchCountLoc1 + "/" + page.state.stitchCountLoc2 +
            //     "/" + artLocation + "/" + page.state.selectedArtChoice,
            url:config.PCNA_SERVICE_URL+"GetProductDetails?ItemCode="+page.state.userSelectedProduct+"&DecoLoc1="+ page.state.selectedDeco1 +            
            "&DecoLoc2="+ page.state.selectedDeco2 +"&noColor1="+ colr1 +"&noColor2="+ colr2 +"&StitchCountLoc1="+ page.state.stitchCountLoc1 +
            "&StitchCountLoc2="+ page.state.stitchCountLoc2 +"&ArtNo="+artLocation+"&SameArtType="+ page.state.selectedArtChoice,

            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        this.setState({loading:true});
        axios(formConfig1)
            .then(function (response) {
                if(response.data.errorMsg == ""){
                    page.state.selectedProductDetails = response.data.objProduct
                    page.state.Loc1PricingType=response.data.objProduct.loc1PricingType
                    page.state.Loc2PricingType=response.data.objProduct.loc2PricingType
                    page.state.artQty1 = response.data.artQty1
                    page.state.artQty2 = response.data.artQty2
    
                    page.setState({errorMessage:!!response.data?.applicableDecoMethods && 
                        response.data.applicableDecoMethods.length < 1 ? "No deco methods found for the selected product" : null});
    
                    if(response.data.applicableDecoMethods.length > 0){
                        page.state.decoData = response.data.applicableDecoMethods 
                        // page.state.colorsMax1 = response.data.applicableDecoMethods[0]?.colorsMax
                        // page.state.colorsMax2= response.data.applicableDecoMethods[0]?.colorsMax
                    }
                    // page.state.decoData = response.data.applicableDecoMethods
                    // page.state.colorsMax1 = response.data.applicableDecoMethods[0]?.colorsMax
                    page.state.selectedDeco1= page.state.selectedDeco1
                    page.state.selectedDeco2= page.state.selectedDeco2
                    // page.state.colorsMax2= response.data.applicableDecoMethods[0]?.colorsMax
                    page.state.selectedMethodIsDefault=response.data.selectedMethodIsDefault
    
                    page.setState({
                        displayTable: response.data.objProduct.lstDiffPrices,
                        loading:false,                        
                        DisplayColor1:response.data.displayColor1,
                        DisplayColor2:response.data.displayColor2
                    })
                    if (page.state.productQuantityInputValue != "" && page.state.productQuantityInputValue != undefined) {
                        page.checkProductPrice1(page.state.productQuantityInputValue);
                    }
                }
                else{
                    page.setState({
                        errorMessage : response.data.errorMsg, loading:false
                    })
                }
                
            }).catch(err => {this.setState({loading:false});})

        // ////////////////////

        // page.state.selectedProductBU=selectedBU
        // page.calculateSetupPrice1();
        // // if(page.state.selectedArtChoice.toLocaleLowerCase()=="no-different"){
        //     page.calculateSetupPrice2();
        // // }

        // if(page.state.productQuantityInputValue!="" && page.state.productQuantityInputValue!=undefined){
        //     page.checkProductPrice1(page.state.productQuantityInputValue);
        // }
        // ///////////////////
    }

    onselectDeco2(e) {
        var page = this
        if (e.target.value != "" && e.target.value != undefined) {
            var MaxColor = ""
            var DecorationName = ""
            page.state.decoData.map((x) => {
                if (e.target.value == x.decoName) {
                    MaxColor = x.colorsMax
                    DecorationName = x.hyphanateName
                }
            })
            page.state.selectedDeco2 = e.target.value
            page.setState({
                DecorationFullName2 : DecorationName,
                colorsMax2: MaxColor
            })
            if (e.target.value != "Embroidery") {
                page.setState({
                    stitchCountLoc2: 0.00
                })
            }
            if (e.target.value == "Embroidery") {
                page.setState({
                    stitchCountLoc2: 12000
                })
            }
            page.calculateSetupPrice2();
            // console.log("/////////select deco 2/////////////")
            page.getAllProductCallOninputChange();
            page.checkProductPrice1(page.state.productQuantityInputValue);
        }
    }

    checkColorsLocation1(e) {
        debugger
        var page = this
        if (e.target.value > page.state.colorsMax1 && page.state.colorsMax1 > 0) {
            page.setState({
                colorsInputErr1: "You cannot enter colors greater than '" + page.state.colorsMax1 + "'"
            })

        }
        else {
            page.state.productColorsInputValue1 = e.target.value
            page.setState({
                colorsInputErr1: ""
            })
            if(e.target.value!=""){
                page.calculateSetupPrice1();
                // console.log("/////////check color location 1/////////////")
                page.getAllProductCallOninputChange();
                page.checkProductPrice1(page.state.productQuantityInputValue);
            }
            
        }
    }

    checkColorsLocation2(e) {
        var page = this
        if (e.target.value > page.state.colorsMax2 && page.state.colorsMax2 > 0) {
            page.setState({
                colorsInputErr2: "You cannot enter colors greater than '" + page.state.colorsMax2 + "'"
            })
        }
        else {
            page.state.productColorsInputValue2 = e.target.value
            page.setState({
                colorsInputErr2: ""
            })
            if(e.target.value!=""){
            page.calculateSetupPrice2()
            // console.log("/////////check color location 2/////////////")
            page.getAllProductCallOninputChange();
            page.checkProductPrice1(page.state.productQuantityInputValue);
            }
        }
    }

    calculateSetupPrice1() {
        
        if (this.state.selectedDeco1 != "" && this.state.selectedProductBU != "" && this.state.productColorsInputValue1 != "" &&
            this.state.selectedDeco1 != undefined && this.state.selectedProductBU != undefined && this.state.productColorsInputValue1 != undefined) {
            if (this.state.selectedProductBU == "TPL") {
                this.setState({
                    setupPrice1: 0
                })
            }
            else {
                if (this.state.productColorsInputValue1 == 1 || this.state.productColorsInputValue1 == "1") {
                    //   SELECT SingleColorPrice
                    //   FROM SetupRunCharges
                    //   WHERE EXISTS (SELECT SingleColorPrice FROM SetupRunCharges WHERE Lookup='Laser'); //user selected deco
                    var setupPrice = 0;
                    
                    this.state.setupchargeData.map((x) => {
                        if (x.lookup.toLowerCase() == this.state.selectedDeco1.toLowerCase()) {
                            
                            setupPrice = x.singleColorPrice
                            this.setState({
                                setupPrice1: x.singleColorPrice
                            })
                        }
                    })
                    if (setupPrice == 0 || setupPrice == "" || setupPrice == undefined) {
                        this.state.setupchargeData.map((x) => {
                            if (x.lookup.toLowerCase() == "default") {
                                
                                this.setState({
                                    setupPrice1: x.singleColorPrice
                                })
                            }
                        })
                    }

                }
                else {
                    //   SELECT MultiColorPrice 
                    //   FROM SetupRunCharges
                    //   WHERE EXISTS (SELECT MultiColorPrice FROM SetupRunCharges WHERE Lookup='Laser'); //user selected deco
                    var setupPrice = 0;
                    this.state.setupchargeData.map((x) => {
                        if (x.lookup.toLowerCase() == this.state.selectedDeco1.toLowerCase()) {
                            setupPrice = x.multiColorPrice
                            this.setState({
                                setupPrice1: x.multiColorPrice
                            })
                        }
                    })
                    if (setupPrice == 0 || setupPrice == "" || setupPrice == undefined) {
                        this.state.setupchargeData.map((x) => {
                            if (x.lookup.toLowerCase() == "default") {
                                this.setState({
                                    setupPrice1: x.multiColorPrice
                                })
                            }
                        })
                    }
                }
            }
        }
    }

    calculateSetupPrice2() {
        if (this.state.selectedDeco2 != "" && this.state.selectedProductBU != "" && this.state.productColorsInputValue2 != "" &&
            this.state.selectedDeco2 != undefined && this.state.selectedProductBU != undefined && this.state.productColorsInputValue2 != undefined) {
            if (this.state.selectedProductBU == "TPL") {
                this.setState({
                    setupPrice2: 0
                })
            }
            else {
                if (this.state.productColorsInputValue2 == 1 || this.state.productColorsInputValue2 == "1") {
                    //   SELECT SingleColorPrice
                    //   FROM SetupRunCharges
                    //   WHERE EXISTS (SELECT SingleColorPrice FROM SetupRunCharges WHERE Lookup='Laser'); //user selected deco
                    var setupPrice = 0;
                    this.state.setupchargeData.map((x) => {
                        if (x.lookup.toLowerCase() == this.state.selectedDeco2.toLowerCase()) {
                            setupPrice = x.singleColorPrice
                            this.setState({
                                setupPrice2: x.singleColorPrice
                            })
                        }
                    })
                    if (setupPrice == 0 || setupPrice == "" || setupPrice == undefined) {
                        this.state.setupchargeData.map((x) => {
                            if (x.lookup.toLowerCase() == "default") {
                                this.setState({
                                    setupPrice2: x.singleColorPrice
                                })
                            }
                        })
                    }

                }
                else {
                    //   SELECT MultiColorPrice 
                    //   FROM SetupRunCharges
                    //   WHERE EXISTS (SELECT MultiColorPrice FROM SetupRunCharges WHERE Lookup='Laser'); //user selected deco
                    var setupPrice = 0;
                    this.state.setupchargeData.map((x) => {
                        if (x.lookup.toLowerCase() == this.state.selectedDeco2.toLowerCase()) {
                            setupPrice = x.multiColorPrice
                            this.setState({
                                setupPrice2: x.multiColorPrice
                            })
                        }
                    })
                    if (setupPrice == 0 || setupPrice == "" || setupPrice == undefined) {
                        this.state.setupchargeData.map((x) => {
                            if (x.lookup.toLowerCase() == "default") {
                                this.setState({
                                    setupPrice2: x.multiColorPrice
                                })
                            }
                        })
                    }
                }
            }
        }
    }

    changestichcount1(e) {
        var page = this;
        //page.state.stitchCountLoc1=e.target.value
        this.setState({
            stitchCountLoc1: e.currentTarget.value
        })
        // console.log("/////////stitch count 1/////////////")
        // console.log("page state",this.state);
        // ;
        // page.getAllProductCallOninputChange();
        // page.checkProductPrice1(page.state.productQuantityInputValue);
    }

    changestichcount2(e) {
        // var page = this;
        // page.state.stitchCountLoc2=e.target.value
        this.setState({
            stitchCountLoc2: e.target.value
        })
        // console.log("/////////stitch count 2/////////////")
        // console.log("page state",this.state);
        // page.getAllProductCallOninputChange();
        // page.checkProductPrice1(page.state.productQuantityInputValue);
    }

    calculateStickCount(e) {
        
        this.getAllProductCallOninputChange();
        this.checkProductPrice1(this.state.productQuantityInputValue);
    }

    onPricelevel(e) {
        var page = this
        if (e.target.value != "EQP-%") {
            page.state.percentageOffValue = 0.00
        }

        page.setState({
            selectedPriceLevel: e.target.value
        })
        console.log("/////////price level/////////////")
        page.getAllProductCallOninputChange();
        page.checkProductPrice1(page.state.productQuantityInputValue);
    }

    changePercentageOff(e){
        
        var page=this
        page.state.percentageOffValue=e.target.value
            // page.setState({
            //     selectedPriceLevel:e.target.value
            // })
            page.checkProductPrice1(page.state.productQuantityInputValue);
        //const re = /\d{0,2}(\.\d{1,2})?/;
        //if (e.target.value === '' || re.test(e.target.value)) {}

    }

    render() {
        
        var page = this;
        
        // console.log("Decoooooo1111")
        // console.log(page.state.artQty1+"////////artQty1")
        // console.log(page.state.artQty2+"////////artQty222")
        // console.log(page.state.loc1Runchrg+"////////Loca1 charge")
        var locationValue = (page.state.productLocationInputValue != undefined && page.state.productLocationInputValue != "") ?
            page.state.productLocationInputValue : 0;
        var qty = (page.state.productQuantityInputValue != undefined && page.state.productQuantityInputValue != "") ?
            page.state.productQuantityInputValue : 0;
        var setupPrice1 = (page.state.setupPrice1 != undefined && page.state.setupPrice1 != "") ?
            (page.state.selectedArtChoice == "true" ? page.state.setupPrice1 * locationValue : page.state.setupPrice1) : 0.00;
        var setupPrice2 = (page.state.setupPrice2 != undefined && page.state.setupPrice2 != "") ?
            (page.state.selectedArtChoice != "true" ? page.state.setupPrice2 : 0.00) : 0.00;
        // var deco1 = (page.state.artQty1 != undefined && page.state.artQty1 != "") ?
        //     (page.state.selectedArtChoice == "true" ? (page.state.artQty1 * locationValue * qty) : (page.state.artQty1 * qty)) : 0.00;
        var deco1 = (page.state.artQty1 != undefined && page.state.artQty1 != "") ? (page.state.artQty1 * qty) : 0.00;
        var deco2 = (page.state.artQty2 != undefined && page.state.artQty2 != "") ?
            (page.state.selectedArtChoice != "true" ? (page.state.artQty2 * 1 * qty) : 0.00) : 0.00;
        var selectedDeco1=(page.state.selectedDeco1!=undefined && page.state.selectedDeco1!="")?page.state.selectedDeco1:""; //== "Embroidery"
        var selectedDeco2=(page.state.selectedDeco2!=undefined && page.state.selectedDeco2!="")?page.state.selectedDeco2:"";
      //  var Runcharge1 = (page.state.loc1Runchrg != "" && page.state.loc1Runchrg != undefined) ?
      //      page.state.loc1Runchrg * deco1.toFixed(3) : 0.00
      //  var Runcharge2 = (page.state.loc2Runchrg != "" && page.state.loc2Runchrg != undefined) ?
       //     page.state.loc2Runchrg * deco2.toFixed(3) : 0.00
        var Runcharge1 =(page.state.selectedMethodIsDefault!=undefined && page.state.selectedMethodIsDefault==true )?
        0.00 //no runcharge for 1st location if deco methd is default.. suggested by Jose
        :        
        ((page.state.loc1Runchrg != "" && page.state.loc1Runchrg != undefined) ?
            // (page.state.Loc1PricingType!=undefined && page.state.Loc1PricingType!="" && 
            // page.state.Loc1PricingType=="DX Color"||selectedDeco1== "Embroidery" || selectedDeco1=="Laser" || selectedDeco1=="Deboss")? 
            // (page.state.loc1Runchrg*qty): //// in Digital printing no of location doesn't matter (Suggested by Jose)
            page.state.loc1Runchrg * deco1.toFixed(3) : 0.00)
        
        var Runcharge2 = (locationValue==2)?((page.state.loc2Runchrg != "" && page.state.loc2Runchrg != undefined) ?
            // (page.state.Loc2PricingType!=undefined && page.state.Loc2PricingType!="" && 
            // page.state.Loc2PricingType=="DX Color"||selectedDeco2== "Embroidery"|| selectedDeco2=="Laser" || selectedDeco2=="Deboss")?
            // (page.state.loc2Runchrg * qty): //// in Digital printing no of location doesn't matter (Suggested by Jose)
            page.state.loc2Runchrg * deco2.toFixed(3) : 0.00):0.00
    

        // console.log("/////////setupPrice1 " + setupPrice1)
        // console.log("/////////setupPrice2 " + setupPrice2)
        // console.log("/////" + (Math.round(setupPrice1, 2) + Math.round(setupPrice2, 2)) * 0.80)
        //  console.log("/////////Loc1 Runcharge " + page.state.loc1Runchrg)
        //  console.log("/////////Loc 1 Pricing " + page.state.Loc1PricingType)
        //  console.log(Runcharge1)
        // console.log("/////" + (page.state.loc1Runchrg * deco1.toFixed(3)))

        // console.log(this.state.selectedPriceLevel)

        return (
            <div className="d-flex flex-column-fluid" >
                <div className="col-md-9 s-black">
                    <div className="card card-custom overflow-hidden">
                        <div className="card-body p-0">
                            <div className="row justify-content-center px-8 py-md-10 px-md-0">
                                <div className="col-md-9">
                                    <div className="d-flex justify-content-between pb-md-10 flex-column flex-md-row">
                                        <h1 className="display-4 font-weight-boldest">Quote Generation</h1>
                                    </div>
                                    {/* <TopProgressBarLoader isLoading={this.state.loading} className=""/> */}
                                    <ScreenOverlayLoader isLoading={this.state.loading}/>
                                    <div className="border-bottom w-100"></div>
                                    {
                                        page.state.selectedProductErr != "" ?
                                            <div class="alert alert-danger" role="alert">
                                                {page.state.selectedProductErr}
                                            </div>
                                            : ""}
                                    {!!this.state.errorMessage && 
                                        <div className="alert alert-danger">
                                            {this.state.errorMessage}
                                        </div>
                                    }
                                    <div className="row pt-4" >
                                        <div className="col-md-4 text-left pt-3"  >
                                            <span className="font-weight-bolder mb-2 mt-2 ">Product
                                            {page.state.productListLoader == true ? <img className="mt-2 text-left" src={loader} style={{ 'width': '20px', float: 'right' }} /> : ""}</span>
                                        </div>
                                        <div className="col-md-8">
                                            <Select
                                                id="test_select"
                                                name="form-field-name"
                                                value={this.value}
                                                options={page.state.productList}
                                                onChange={page.getProductPricing.bind(this)}
                                                components={{ MenuList }}
                                                className="text-left"
                                                placeholder="Select a product"
                                            />
                                        </div>
                                        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                            <div class="modal-dialog" role="document">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title" id="exampleModalLabel">Pricing Details</h5>
                                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                            <b>X</b>
                                                        </button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <div className="sticky-model"   >
                                                            {page.state.selectedProductDetails != undefined && page.state.selectedProductDetails != "" ?
                                                                <div  >
                                                                    <table className="table  table-bordered mr-1 ml-0 table-hover ">
                                                                        <thead  >
                                                                            <tr>
                                                                                <th className="th-stick" > Column</th>
                                                                                <th className="th-stick"  > Beg Qty</th>
                                                                                {page.state.productLocationInputValue == 0 || page.state.productLocationInputValue == "0"
                                                                                    || page.state.productLocationInputValue == "" ? <th className="th-stick">Blank $</th> : <th className="th-stick">Item $</th>}
                                                                                <th className="th-stick" >Run Chg Loc 1</th>
                                                                                {page.state.selectedArtChoice != "true" ? 
                                                                                <th className="th-stick" >Run Chg Loc 2</th> : ""}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                page.state.displayTable != undefined ?
                                                                                    page.state.displayTable.length > 0 ?
                                                                                        page.state.displayTable.map((data, i) => {
                                                                                            // console.log(data.coded) 
                                                                                            return (
                                                                                                <tr>
                                                                                                    <td>{data.columnNo == 0 || data.columnNo == "0" ? "LTM" : "Col" + (i)}</td>
                                                                                                    <td>{Math.round(data.begQty, 0)}</td>
                                                                                                    {page.state.productLocationInputValue == 0 || page.state.productLocationInputValue == "0" ||
                                                                                                        page.state.productLocationInputValue == "" ?
                                                                                                        //<td>${(data.bCoded !== undefined) ? data.bCoded.toFixed(3) : 0.0}</td>: 
                                                                                                        //<td>${(data.coded != undefined) ? parseFloat(data.coded).toFixed(3) : 0.0}</td>
                                                                                                        <td>${
                                                                                                            this.state.ToggleValue === "Net" ? 
                                                                                                            this.applyPercentage(data.bCoded,this.state.netItemPricePercentage) :
                                                                                                            this.applyPercentage(data.bCoded,1)
                                                                                                        }</td> :
                                                                                                        <td>${
                                                                                                            this.state.ToggleValue === "Net" ? 
                                                                                                            this.applyPercentage(data.coded,this.state.netItemPricePercentage) :
                                                                                                            this.applyPercentage(data.coded,1)
                                                                                                        }</td>
                                                                                                    }
                                                                                                    <td>${
                                                                                                        this.state.ToggleValue === "Net" ? 
                                                                                                        this.applyPercentage(data.runChargeLoc1,this.state.netSetupAndRunPercentage) :
                                                                                                        this.applyPercentage(data.runChargeLoc1,1)
                                                                                                    }</td>
                                                                                                    {this.state.selectedArtChoice != "true" ? <td>${
                                                                                                       this.state.ToggleValue === "Net" ? 
                                                                                                       this.applyPercentage(data.runChargeLoc2,this.state.netSetupAndRunPercentage) :
                                                                                                       this.applyPercentage(data.runChargeLoc2,1)
                                                                                                    }</td> : ""}
                                                                                                </tr>
                                                                                            )                                                                                            
                                                                                        })
                                                                                        : ""
                                                                                    : ""
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                : ""
                                                            }
                                                        </div>
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                                        {/* <button type="button" class="btn btn-primary">Save changes</button> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* table details */}
                                    </div>

                                    <div className="row mt-4" >
                                        <div className="col-md-4 text-left pt-3" >

                                            <span className="font-weight-bolder mb-2 mt-2 ">Quantity
                                            {page.state.selectedProductPricingLoader == true ?
                                                    <img className="mt-2 text-left" src={loader} style={{ 'width': '20px', float: 'right' }} /> : ""}
                                            </span>
                                        </div>
                                        <div className="col-md-8" disabled={!!this.state.errorMessage}>
                                            <div className="">
                                                <input id="quantityField" readOnly={page.state.showQty} type="number" className="form-control form-control-lg"
                                                    placeholder="Quantity Required" onChange={(event) => page.checkProductPrice(event)}
                                                    value={page.state.productQuantityInputValue}></input>
                                            </div>
                                            <span className="text-left" style={{ color: 'red' }}>{page.state.productQuantityInputErr}</span>
                                        </div>
                                    </div>
                                    {/* ==== */}
                                    <div className="row pt-6" >

                                        <div className="col-md-4  text-left pt-3">
                                            <span className="font-weight-bolder mb-2 mt-2">Customer price level</span>
                                        </div>
                                        <div className="col-md-8" disabled={!!this.state.errorMessage}>
                                            <select className="form-control" id="drpPricelevel" disabled={page.state.showQty}
                                            onChange={(event) => page.onPricelevel(event)}>
                                                {
                                                    this.state.lstCustomerPrice != "" && this.state.lstCustomerPrice != undefined ?
                                                        this.state.lstCustomerPrice.map(function (record, i) {
                                                            return (
                                                                <option key={record.name} value={record.name}>{record.name}</option>
                                                            )
                                                        })
                                                        : ""
                                                }
                                            </select>
                                        </div>

                                    </div>
                                    {/* ==== */}
                                    {this.state.selectedPriceLevel != "" && this.state.selectedPriceLevel != undefined
                                        && this.state.selectedPriceLevel == "EQP-%" ?
                                        <div className="d-flex justify-content-between pt-6" disabled={!!this.state.errorMessage}>
                                            <div className="d-flex flex-column flex-root">
                                                <div className="">Percentage off :&nbsp;
                                                <input id="txtEQPPerc" type="text" placeholder=""
                                                        onChange={(event) => page.changePercentageOff(event)}
                                                        value={page.state.percentageOffValue}></input>
                                                </div>

                                            </div>
                                        </div>
                                        : ""
                                    }
                                    {/* ==== */}
                                    {/* ==== */}
                                    {/* <div className="alert alert-custom alert-default mt-5" role="alert">
                                        <div className="alert-icon">
                                            <span className="svg-icon svg-icon-primary svg-icon-xl">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                        <rect x="0" y="0" width="24" height="24"></rect>
                                                        <path d="M7.07744993,12.3040451 C7.72444571,13.0716094 8.54044565,13.6920474 9.46808594,14.1079953 L5,23 L4.5,18 L7.07744993,12.3040451 Z M14.5865511,14.2597864 C15.5319561,13.9019016 16.375416,13.3366121 17.0614026,12.6194459 L19.5,18 L19,23 L14.5865511,14.2597864 Z M12,3.55271368e-14 C12.8284271,3.53749572e-14 13.5,0.671572875 13.5,1.5 L13.5,4 L10.5,4 L10.5,1.5 C10.5,0.671572875 11.1715729,3.56793164e-14 12,3.55271368e-14 Z" fill="#000000" opacity="0.3"></path>
                                                        <path d="M12,10 C13.1045695,10 14,9.1045695 14,8 C14,6.8954305 13.1045695,6 12,6 C10.8954305,6 10,6.8954305 10,8 C10,9.1045695 10.8954305,10 12,10 Z M12,13 C9.23857625,13 7,10.7614237 7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 C17,10.7614237 14.7614237,13 12,13 Z" fill="#000000" fill-rule="nonzero"></path>
                                                    </g>
                                                </svg>
                                            </span>
                                        </div>
                                        <div className="alert-text">Once the
											<code>product (code)</code> and the required
											<code>quantity</code> are selected, the system will fetch the product pricing.
                                        </div>
                                    </div> */}
                                    {/* //===== add changes */}
                                    <div className="row pt-6" >
                                        <div className="col-md-4 text-left pt-3"   >
                                            <span className="font-weight-bolder mb-2 mt-2 ">Add art and location  </span>
                                        </div>
                                        <div className="col-md-8" disabled={!!this.state.errorMessage}>
                                            <div className="">
                                                <input id="locationField" readOnly={page.state.showQty} type="number" className="form-control form-control-lg" placeholder="location Required"
                                                    onChange={(event) => page.checkProductLocation(event)} 
                                                    value={page.state.productLocationInputValue}></input>
                                            </div>
                                            <span className="text-left" style={{ color: 'red' }}>{page.state.locationInputErr}</span>
                                            <span className="text-left" style={{ color: 'red' }}>
                                                {( this.state.productLocationInputValue != "2" || this.state.productLocationInputValue != 2) &&
                                                    this.state.selectedArtChoice == "false" ? "Select valid location value." : ""}</span>
                                        </div>
                                    </div>

                                    <div className="row pt-6">
                                        <div className="col-md-4 text-left pt-3" >
                                            <span className="font-weight-bolder mb-2 mt-2 ">Same art and deco method?</span>
                                        </div>
                                        <div className="col-md-8" disabled={!!this.state.errorMessage}>
                                            <div className="ml-0 pl-0">
                                                <select className="form-control" value={this.value} id="drpArtChoice" disabled={page.state.showQty}                                                
                                                    onChange={(event) => page.getArtchioce(event)}>
                                                        <option value="true" select>YES-Same</option>
                                                        {page.state.productLocationInputValue==2?                                                        
                                                        <option value="false" >NO-Different</option>
                                                        :""}
                                                    
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* {
                                page.state.productQuantityInputValue != "" && page.state.productQuantityInputValue > 0 ?
                                    <div className="col-md-8 ml-35">
                                    <div className="row justify-content-center bg-gray-100 py-8 px-8 py-md-10 px-md-0" >
                                        <table className="table s-black">
                                            <thead>
                                                <tr>
                                                    <th className="font-weight-bold  text-uppercase">Product</th>
                                                    <th className="font-weight-bold  text-uppercase">Quantity</th>
                                                    <th className="font-weight-bold  text-uppercase">Coded Price</th>
                                                    <th className="font-weight-bold  text-uppercase">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="font-weight-bolder">
                                                    <td>{page.state.selectedProductName}</td>
                                                    <td>{page.state.productQuantityInputValue}</td>
                                                    <td>${page.state.perItemCodedPrice}</td>
                                                    <td className="text-danger font-size-h3 font-weight-boldest">${page.state.totalCodedPrice.toFixed(3)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    </div>
                                    : ""
                            } */}
                            {/* //===changes location 1*/}
                            <hr />
                            <div className="container">
                            <div className="row justify-content-md-center p-5" disabled={!!this.state.errorMessage}>
                                
                                    <div className={this.state.selectedArtChoice != "true" ? "col-lg-5 d-flex flex-column px-0 border border-primary my-5 mx-2" : "col-lg-5 d-flex flex-column px-0 border border-primary my-5 mx-2"}>
                                        <div className="p-5">
                                            <div className="font-weight-bolder px-5 text-left">Location - 1  </div>
                                            <div class="dropdown-divider my-5"></div>
                                            <div>
                                                <div className="row my-5 align-items-center">
                                                    <div className="col-md-3">
                                                        <span className="font-weight-bolder text-left">Select Deco </span>
                                                    </div>
                                                    <div className="col-md-9">
                                                        <select id="drpDeco1" className="form-control" disabled={page.state.showQty} 
                                                        onChange={(event) => page.onselectDeco1(event)}>
                                                            {                                                            
                                                                this.state.decoData != "" && this.state.decoData != undefined ?
                                                                    this.state.decoData.map(function (record, i) {
                                                                        
                                                                        return (
                                                                            <option key={record.colorsMax} value={record.name } 
                                                                            selected={record.name==page.state.selectedDeco1?true:false}  >{record.hyphanateName}</option>
                                                                        )
                                                                    })
                                                                    : ""
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                                {/* ==== */}
                                                {this.state.selectedDeco1 != "" && this.state.selectedDeco1 != undefined && this.state.selectedDeco1 == "Embroidery" ?
                                                    <div className="row my-5 align-items-center">
                                                        <div className="col-md-3">
                                                            <span className="font-weight-bolder text-left">Stitch count  </span>
                                                        </div>
                                                        <div className="col-md-9">
                                                            <div className="form-group">
                                                                <input id="txtStitchCnt" className="form-group" type="number" placeholder=""
                                                                    onChange={(event) => page.changestichcount1(event)} value={page.state.stitchCountLoc1}
                                                                    onBlur={this.calculateStickCount.bind(this)}
                                                                    className="form-control form-control-lg"></input>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    : ""
                                                }
                                                {/* ==== */}

                                                <div className="row my-5 align-items-center">
                                                    <div className="col-md-3">
                                                        <span className="font-weight-bolder text-left"># of colors  </span>
                                                    </div>
                                                    <div className="col-md-9">
                                                    <input id="loc1ColorNo" type="number" className="form-control form-control-lg" 
                                                            placeholder="color" disabled={page.state.showQty}
                                                                onChange={(event) => page.checkColorsLocation1(event)} value={page.state.productColorsInputValue1}></input>
                                                        <span className="text-left mt-2" style={{ color: 'red' }}>{page.state.colorsInputErr1}</span>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        {/* {page.state.productQuantityInputValue != "" && page.state.productQuantityInputValue > 0 ?
                                                <div className="bg-gray-100 p-5 flex-grow-1 d-flex align-items-center">
                                                    <div className="flex-fill">
                                                        <div className="row px-5 justify-content-center text-left my-3">
                                                            <div className="col-md-6 col-sm-12 font-weight-bold text-uppercase text-md-left text-sm-center">Setup charge</div>
                                                            <div className="col-md-6 col-sm-12 font-weight-bolder text-center">${Math.round(setupPrice1, 3).toFixed(3)}</div>
                                                        </div>
                                                        <div className="row px-5 justify-content-center text-left my-3">
                                                            <div className="col-md-6 col-sm-12 font-weight-bold text-uppercase text-md-left text-sm-center">Deco qty charged</div>
                                                            <div className="col-md-6 col-sm-12 font-weight-bolder text-center">{deco1} </div>
                                                        </div>
                                                        <div className="row px-5 justify-content-center text-left my-3">
                                                            <div className="col-md-6 col-sm-12 font-weight-bold  text-uppercase text-md-left text-sm-center">Run charge</div>
                                                            <div className="col-md-6 col-sm-12 text-danger font-size-h5 font-weight-boldest text-center">${(Runcharge1).toFixed(3)}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                : ""
                                            } */}
                                    </div>

                                    {/* //====location2 */}
                                    <div className={(this.state.selectedArtChoice == "false" && this.state.productLocationInputValue==2 ) ? "col-lg-5 d-flex flex-column px-0 border border-primary my-5 mx-2" : "d-none"} >
                                        {(this.state.selectedArtChoice == "false" && this.state.productLocationInputValue==2 )  ?
                                            <div>
                                                <div className="p-5">
                                                    <div className="font-weight-bolder px-5 text-left">Location - 2  </div>
                                                    <div class="dropdown-divider my-5"></div>
                                                    <div>
                                                        <div className="row my-5 align-items-center">
                                                            <div className="col-md-3">
                                                                <span className="font-weight-bolder text-left">Select Deco </span>
                                                            </div>
                                                            <div className="col-md-9">
                                                                <select className="form-control" onChange={(event) => page.onselectDeco2(event)}>
                                                                    {
                                                                        this.state.decoData != "" && this.state.decoData != undefined ?
                                                                            this.state.decoData.map(function (record, i) {
                                                                                
                                                                                return (
                                                                                    <option key={record.colorsMax} value={record.name} 
                                                                                    selected={record.name==page.state.selectedDeco2?true:false} >{record.hyphanateName}</option>
                                                                                )
                                                                            })
                                                                            : ""
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                        {/* ==== */}
                                                        {this.state.selectedDeco2 != "" && this.state.selectedDeco2 != undefined && this.state.selectedDeco2 == "Embroidery" ?
                                                            <div className="row my-5 align-items-center">
                                                                <div className="col-md-3">
                                                                    <span className="font-weight-bolder text-left">Stitch count  </span>
                                                                </div>
                                                                <div className="col-md-9">
                                                                    <input id="Loc2StitchCnt" type="number" placeholder="" 
                                                                    onChange={(event) => page.changestichcount2(event)}
                                                                    onBlur={this.calculateStickCount.bind(this)}
                                                                        value={page.state.stitchCountLoc2} className="form-control form-control-lg"></input>
                                                                </div>
                                                            </div>
                                                            : ""
                                                        }
                                                        <div className="row my-5 align-items-center">
                                                            <div className="col-md-3">
                                                                <span className="font-weight-bolder text-left"># of colors  </span>
                                                            </div>
                                                            <div className="col-md-9">
                                                                <input id="loc2ColorNo" type="number" className="form-control form-control-lg" placeholder="color"
                                                                    onChange={(event) => page.checkColorsLocation2(event)} value={page.state.productColorsInputValue2}></input>
                                                                <span className="text-left" style={{ color: 'red' }}>{page.state.colorsInputErr2}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                    {/* {
                                                        page.state.productQuantityInputValue != "" && page.state.productQuantityInputValue > 0 ?
                                                            <div className="bg-gray-100 p-5 flex-grow-1 d-flex align-items-center">
                                                                <div className="flex-fill">
                                                                    <div className="row px-5 justify-content-center text-left my-3">
                                                                        <div className="col-md-6 col-sm-12 font-weight-bold text-uppercase text-md-left text-sm-center">Setup charge</div>
                                                                        <div className="col-md-6 col-sm-12 font-weight-bolder text-center">${Math.round(setupPrice2, 3).toFixed(3)}</div>
                                                                    </div>
                                                                    <div className="row px-5 justify-content-center text-left my-3">
                                                                        <div className="col-md-6 col-sm-12 font-weight-bold text-uppercase text-md-left text-sm-center">Deco qty charged</div>
                                                                        <div className="col-md-6 col-sm-12 font-weight-bolder text-center">{deco2} </div>
                                                                    </div>
                                                                    <div className="row px-5 justify-content-center text-left my-3">
                                                                        <div className="col-md-6 col-sm-12 font-weight-bold  text-uppercase text-md-left text-sm-center">Run charge</div>
                                                                        <div className="col-md-6 col-sm-12 text-danger font-size-h5 font-weight-boldest text-center">${(Runcharge2).toFixed(3)}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            : ""
                                                    } */}
                                            </div>
                                            : ""
                                        }
                                    </div>
                                
                            </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 mt-10 position-relative">
                    <div className="h-100">
                        <div className="card card-custom bg-primary">
                            <div className="card-header border-0">
                                <div className="card-title d-flex align-items-center">
                                    <span className="card-icon">
                                        <i className="flaticon2-chat-1 text-white"></i>
                                    </span>
                                    <h3 className="card-label text-white">
                                        Quote
                                    </h3>
                                    <Switch 
                                            onChange={this.handleChange} 
                                            checked={this.state.CheckedValue}
                                            handleDiameter={20}
                                            // offColor="#08f"
                                            // onColor="#0ff"
                                            // offHandleColor="#0ff"
                                            // onHandleColor="#08f"
                                            height={24}
                                            width={80}
                                            borderRadius={6}
                                            activeBoxShadow="0px 0px 1px 2px #fffc35"
                                            uncheckedIcon={
                                            <div className="position-relative d-flex align-items-center text-nowrap p-4">
                                                <small className="text-white" style={{position:"absolute", right:"10px"}}>
                                                    Coded
                                                </small>
                                            </div>
                                        }
                                            checkedIcon={
                                            <div className="d-flex align-items-center text-nowrap position-relative p-4">
                                                <small className="text-white" style={{position:"absolute", left:"10px"}}>
                                                    Net
                                                </small>
                                            </div>
                                        }
                                        />
                                    </div>
                                <div className="card-toolbar">
                                {page.state.selectedProductDetails != undefined && page.state.selectedProductDetails != "" ?
                                    <React.Fragment>
                                                <button type="button" class="btn btn-secondary btn-sticky" data-toggle="modal" data-target="#exampleModal">
                                                    Show Details
                                       </button>
                                    </React.Fragment> : " "}
                                </div>
                            </div>
                            <div className="separator separator-solid separator-white opacity-20"></div>
                            <div className="card-body text-white overflow-auto">
                                <div className="table-responsive">
                                    <table className="table table-head-custom table-vertical-center">
                                        <tbody>
                                            <tr className="">
                                                {/* <td className="text-justify text-white">Coded Price:</td> */}
                                                <td className="text-justify text-white">Item Unit Price:</td>
                                                <td className="text-right text-white">${page.state.ToggleValue==="Coded" ?
                                                 parseFloat(page.state.perItemCodedPrice).toFixed(3) : parseFloat(page.state.perItemCodedPrice * 0.60).toFixed(3) }</td>
                                            </tr>
                                            <tr className="">
                                                {/* <td className="text-justify text-white">Coded Amount:</td> */}
                                                <td className="text-justify text-white">Item Total:</td>
                                                <td className="text-right text-white">${page.state.ToggleValue==="Coded" ?
                                                 page.state.totalCodedPrice.toFixed(3) : (page.state.totalCodedPrice.toFixed(3) * 0.60).toFixed(3) }</td>
                                                {/* <td className="text-right text-white">${page.state.totalCodedPrice.toFixed(3)}</td> */}
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="font-weight-bolder mt-5"> Configured Price for Setup and Run <br />
                                </div>
                                <div className="table-responsive mt-4">
                                    <table className="table table-head-custom table-vertical-center text-white">

                                        {/* {page.state.selectedArtChoice=="true"?                 */}
                                        <tbody>
                                            {/* <tr>
                                                <td className="text-justify">Net Price:</td>
                                                <td className="text-right">${((page.state.perItemCodedPrice * page.state.productQuantityInputValue) * 0.60).toFixed(3)} </td>
                                            </tr> */}
                                            <tr>
                                                <td className="text-justify">Setup Total:</td>
                                                {/* <td> {(setupPrice1+setupPrice2)*0.80} </td>  */}
                                                {/* <td className="text-right">${((Math.round(setupPrice1, 2) + Math.round(setupPrice2, 2)) * 0.80).toFixed(3)}</td> */}
                                                <td className="text-right">${page.state.ToggleValue==="Coded" ?
                                                 (Math.round(setupPrice1, 3) + Math.round(setupPrice2, 3)) : ((Math.round(setupPrice1, 3) + Math.round(setupPrice2, 3)) * 0.80).toFixed(3) }</td>
                                            </tr>
                                            <tr>
                                                <td className="text-justify">Run Total:</td>
                                                {/* <td> {(page.state.productLocationInputValue*page.state.loc1Runchrg)*0.80} </td>  */}
                                                {/* <td className="text-right">${((Math.round(Runcharge1, 2) + Math.round(Runcharge2, 2)) * 0.80).toFixed(3)}</td> */}
                                                <td className="text-right">${page.state.ToggleValue==="Coded" ?
                                                 (Math.round(Runcharge1, 3) + Math.round(Runcharge2, 3)) : ((Math.round(Runcharge1, 3) + Math.round(Runcharge2, 3)) * 0.80).toFixed(3) }</td>
                                            </tr>
                                            <tr>
                                                {/* <td className="text-justify">Configured Item Price:</td> */}
                                                <td className="text-justify">Configured Unit Price:</td>
                                                {/* <td> ${qty==0?0:
                            ((((Math.round(page.state.perItemCodedPrice,2)*Math.round(qty,2))*0.60)+
                            ((Math.round(setupPrice1,2)+Math.round(setupPrice2,2))*0.80)+
                            ((Math.round(Runcharge1,2)+Math.round(Runcharge2,2))*0.80))/qty).toFixed(3)
                         } </td>  */}
                                                <td className="text-right"> ${qty == 0 ? 0 : 
                                                <React.Fragment>
                                                    {page.state.ToggleValue==="Coded" ?  ((((parseFloat(page.state.perItemCodedPrice) * parseFloat(qty))) +
                                                        ((parseFloat(setupPrice1) + parseFloat(setupPrice2))) +
                                                        ((parseFloat(Runcharge1) + parseFloat(Runcharge2)))) / qty).toFixed(3)
                                                        : 
                                                        ((((parseFloat(page.state.perItemCodedPrice) * parseFloat(qty)) * 0.60) +
                                                        ((parseFloat(setupPrice1) + parseFloat(setupPrice2)) * 0.80) +
                                                        ((parseFloat(Runcharge1) + parseFloat(Runcharge2)) * 0.80)) / qty).toFixed(3)
                                                    }
                                                </React.Fragment>
                                                   
                                                } X {qty}</td>
                                            </tr>
                                            <tr className="font-weight-bolder">
                                                {/* <td className="text-justify"><h3>Total:</h3></td> */}
                                                <td className="text-justify"><h3>Configured Item Total:</h3></td>
                                                {page.state.ToggleValue==="Coded" ?
                                                <td className="text-right"><h3>${(((parseFloat(page.state.perItemCodedPrice) * parseFloat(qty))) +
                                                    ((parseFloat(setupPrice1) + parseFloat(setupPrice2))) +
                                                    ((parseFloat(Runcharge1) + parseFloat(Runcharge2)))).toFixed(3)}</h3></td>
                                                :
                                                <td className="text-right"><h3>${(((parseFloat(page.state.perItemCodedPrice) * parseFloat(qty)) * 0.60) +
                                                    ((parseFloat(setupPrice1) + parseFloat(setupPrice2)) * 0.80) +
                                                    ((parseFloat(Runcharge1) + parseFloat(Runcharge2)) * 0.80)).toFixed(3)}</h3></td>
                                                }
                                                
                                                {/* <td> ${(((page.state.perItemCodedPrice*qty)*0.60)+
                            ((setupPrice1+setupPrice2)*0.80)+
                            ((Runcharge1+Runcharge2)*0.80)).toFixed(3)} </td>  */}
                                            </tr>
                                            <tr>
                                                <td className="text-justify">Turn time :</td>
                                                <td className="text-right"> {page.state.turnTime} </td>
                                            </tr>
                                            <tr>
                                                <td className="text-justify">Expedited Turn time:</td>
                                                <td className="text-right"> {page.state.extTurnTime} </td>
                                            </tr>
                                        </tbody>
                                        {/* :
                <tbody>  
                    <tr className="font-weight-bolder">
                    <td className="text-right">Net Price:</td> 
                    <td> {(page.state.perItemCodedPrice*page.state.productQuantityInputValue)*0.60} </td> 
                    </tr>                  
                    {(page.state.setupPrice2!=undefined && page.state.setupPrice2!="")?
                    <tr className="font-weight-bolder">
                    <td className="text-right"> Setup Charge:</td><td> {(page.state.setupPrice1 + page.state.setupPrice2)*0.80} </td>
                    </tr>:""}
                    <tr className="font-weight-bolder">
                     <td className="text-right">Run Charge:</td> 
                     <td> {(page.state.loc1Runchrg + page.state.loc2Runchrg)*0.80} </td> 
                    </tr>
                    <tr className="font-weight-bolder">
                     <td className="text-right">Configured Item Price:</td> 
                     <td> {(((page.state.perItemCodedPrice*page.state.productQuantityInputValue)*0.60)+
                            ((page.state.setupPrice1 + page.state.setupPrice2)*0.80)+
                            ((page.state.loc1Runchrg + page.state.loc2Runchrg)*0.80))/page.state.productQuantityInputValue
                         } </td> 
                         <td>X</td>
                         <td>{page.state.productQuantityInputValue}</td>
                    </tr>
                    <tr className="font-weight-bolder">
                     <td className="text-right">Configured Line Price:</td> 
                     <td> {(((page.state.perItemCodedPrice*page.state.productQuantityInputValue)*0.60)+
                            ((page.state.setupPrice1 + page.state.setupPrice2)*0.80)+
                            ((page.state.loc1Runchrg + page.state.loc2Runchrg)*0.80))} </td> 
                    </tr>
                    <tr className="font-weight-bolder">
                     <td className="text-right">Turn time :</td> 
                     <td>  </td> 
                    </tr>
                    <tr className="font-weight-bolder">
                     <td className="text-right">Expedited Turn time:</td> 
                     <td>  </td> 
                    </tr>
                </tbody>
                    }   */}


                                    </table>
                                    <QuotedConfigurationDetails data={{...this.state, Runcharge1, Runcharge2, setupPrice1, setupPrice2}}/>
                                    <button onClick={() => this.exportExcel()} type="button" class="btn btn-secondary btn-sticky" >Download as excel</button>

                                </div>

                            </div>
                            {/* {(page.state.productLocationInputValue!=undefined && page.state.productLocationInputValue!="" && 
        page.state.selectedArtChoice!=undefined && page.state.selectedArtChoice!="" && 
        page.state.setupPrice1!=undefined && page.state.setupPrice1!="" )? */}



                        </div>
                        {/* :""}    */}
                    </div>

                </div>



            </div >

        );
    }
}


// To fix slowness of react-select when dataset is too large
class MenuList extends Component {
    render() {
        const { options, children, maxHeight, getValue } = this.props;
        const [value] = getValue();
        const initialOffset = options.indexOf(value) * height;

        return (
            <List
                height={maxHeight}
                itemCount={children.length}
                itemSize={height}
                initialScrollOffset={initialOffset}
            >
                {({ index, style }) => <div style={style}>{children[index]}</div>}
            </List>
        );
    }
}


export default withRouter(QuotesNew);